import request from "../../../utils/request";

export const getPlacingInstruments = '/placingInstruments/'
export const exportPlacingInstruments = '/placingInstruments/export'

export function modifyPlacingInstruments(values: any) {
    return request.request({
        url: '/placingInstruments/',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function getPlacingInstrumentsDetail(id: any) {
    return request.request({
        url: '/placingInstruments/detail/',
        method: "get",
        params: {id: id}
    })
}

export function switchStatus(id: any) {
    return request.request({
        url: '/placingInstruments/switchStatus',
        method: "get",
        params: {id: id}
    })
}

export function getInstrumentsByHospital(hospitalId: number) {
    return request.get('/placingInstruments/byHospital', {params: {hospitalId}});
}
export function getInstrumentsByHospitalAndDealer(hospitalId:number, dealerId:number){
    return request.get("/placingInstruments/byHospitalAndDealer", {params: {hospitalId, dealerId}});
}

export function getHospitalByDealer(dealerId: number) {
    return request.get('/placingInstruments/getHospitalByDealer', {params: {dealerId}});
}

export function importPlacingInstruments(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    return request.request({
        url: '/placingInstruments/import',
        method: 'post',
        data: formData
    })
}